<script>

	import {onMount} from "svelte";
	import LmsPercentageBar from "./LmsPercentageBar.svelte";
	import {makeLmsRequest} from "../../service/LmsClient";
	import {LmsUtils} from "../../utils/LmsUtils";
	import Loader from "../../../Common/Loader.svelte";
	import {External, M} from "../../../external";

	export let
		circle = {},
		activePeriod = {};

	let period;
	let loading = true;
	let circles = [];

	let loadCircleContent = async (idx) => {
		let circle = circles[idx];
		circle.children = {
			loading: true
		}
		let url = `/analytics/circle/${circle.id}/completed?from=${period.from}&to=${period.to}`;
		let result = await makeLmsRequest(url);
		if (result.ok) {
			let stats = await result.json();
			circle.children.items = [
				...(stats.pages || []),
				...(stats.groups || [])
			].sort((first, second) => first.uiOrder - second.uiOrder);
		}
		circle.children.loading = false;
		circles[idx] = circle;
	}

	let toggleExpanded = (idx) => {
		let circle = circles[idx];
		circle.expanded = !circle.expanded;
		circles[idx] = circles[idx];
		if (circle.expanded && !circle.children) {
			loadCircleContent(idx);
		}
	}

	onMount(async () => {
		period = LmsUtils.getStartEndTime(activePeriod);
		let url = `/analytics/circle/completed?from=${period.from}&to=${period.to}&id=${circle?.id || ''}&type=CIRCLE`;
		let result = await makeLmsRequest(url);
		if (result.ok) {
			circles = await result.json();
		}
		if (circle?.id && circles.length) {
			toggleExpanded(0);
		}
		loading = false;
	});

</script>

<div class="scrollable-table orders-scrollable-tablee scrollable-table-design strnger-border multi-level-table mb-25">
	<table style="margin-top: 0px;">
		<thead>
		<tr class="flex flex-row align-center" style="padding-bottom: 0px;">
			<td class="checkbox-table"></td>
			<th class="flex-none mw-240" style="padding-left: 20px;"><a>{M.CIRCLE_NAME}</a></th>
			<th class="flex-none mw-120"><a>{M.MEMBERS}</a></th>
			<th class="flex-none mw-180"><a>{M.COMPLETION_RATE}</a></th>
		</tr>
		</thead>
		<tbody style="height: auto;">
		{#if loading}
			<Loader inTable="true"/>
		{:else}
			{#each circles as circle, idx(circle)}
				<tr class="flex flex-row align-center mb-0 mt-10">
					<td class="flex-none checkbox-table">
						<a class="f-left" on:click={() => toggleExpanded(idx)}>
							<svg class="f-left" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
									 fill="#000000">
								<path d="M0 0h24v24H0V0z" fill="none"/>
								{#if circle.expanded}
									<path
										d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
								{:else}
									<path
										d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
								{/if}
							</svg>
						</a>
					</td>

					<td class="flex-none mw-240" style="padding-left: 20px;">{circle.name}</td>
					<td class="flex-none mw-120">{circle.members}</td>
					<td class="flex-none mw-180">
						<LmsPercentageBar filled={circle.count} all={circle.members}/>
					</td>
				</tr>

				{#if circle.expanded}
					{#key circle.children}
						{#if circle.children.loading}
							<Loader inTable="true"/>
						{:else if circle.children.items.length === 0}
							<tr class="inner-table-wrapper">
								<td colspan="4" style="padding: 25px;">{M.NO_TRACKED_CONTENT}</td>
							</tr>
						{:else}
							<tr class="inner-table-wrapper">
								<td colspan="4">
									<table class="inner-table" style="margin-top: 0px;">
										<thead>
										<tr class="flex flex-row align-center" style="padding-bottom: 0px;">
											<th class="checkbox-table"></th>
											<th class="flex-none mw-240" style="padding-left: 20px;"><a>{M.NAME}</a></th>
											<th class="flex-none mw-180">{M.COMPLETION_RATE}</th>
											<th class="flex-none mw-80"></th>
										</tr>
										</thead>
										<tbody style="height: auto;">
										{#each circle.children.items as item}
											<tr class="flex flex-row align-center inner-table-row">
												<td class="checkbox-table"></td>
												<td class="flex-none mw-240" style="padding-left: 20px;">
													{#if item.pages}
														<b class="inner-circle-separator">{item.name} ↓</b>
													{:else}
														{item.name}
													{/if}
												</td>
												<td class="flex-none mw-180">
													<LmsPercentageBar filled={item.count} all={circle.members}/>
												</td>
											</tr>
											{#if item.pages}
												{#each item.pages as page}
													<tr class="flex flex-row align-center inner-table-row">
														<td class="checkbox-table"></td>
														<td class="flex-none mw-240" style="padding-left: 20px;">
															⮑ {page.name}
														</td>
														<td class="flex-none mw-180">
															<LmsPercentageBar filled={page.count} all={circle.members}/>
														</td>
													</tr>
												{/each}
											{/if}
										{/each}
										</tbody>
									</table>
								</td>
							</tr>
						{/if}
					{/key}
				{/if}
			{/each}
		{/if}
		</tbody>
	</table>
</div>
